"use strict";

function btyModelExit() {
    document.addEventListener("click", (function(e) {
        let t = e.target,
            n = document.querySelector(".product-main-slide") ? ".product-main-slide" : ".single-media";
        t.closest(n) || btyMediaAction()
    }))
}

function btyPhotoswipeHandle(e = document) {
    let t = function e(t, n) {
            return t && (n(t) ? t : e(t.parentNode, n))
        },
        n = function(e) {
            (e = e || window.event).preventDefault ? e.preventDefault() : e.returnValue = !1;
            let n = e.target || e.srcElement,
                i = t(n, (function(e) {
                    return e.tagName && "BUTTON" === e.tagName
                }));
            if (!i) return;
            if (
                i.hasAttribute('data-video') ||
                i.hasAttribute('data-external_video') ||
                i.hasAttribute('data-model')
            ) {
                return true;
            }
            let r, a = i.parentNode.parentNode,
                d = a.childNodes,
                c = 0;
            for (let e = 0, t = d.length; e < t; e++)
                if (1 === d[e].nodeType && d[e].querySelector(".media-preview-wrap")) {
                    if (d[e] === i.parentNode) {
                        r = c;
                        break
                    }
                    c++
                } return r >= 0 && o(r, a), !1
        },
        o = function(t, n, o, i) {
            let r = e.querySelector(".pswp");
            if (!r) return;
            let a = function(e) {
                let t, n, o, i = e.querySelectorAll(".product-main-slide .media-preview-wrap"),
                    r = [];
                if (i.length) {
                    for (let e = 0, a = i.length; e < a; e++) {

                    t = i[e];

                    if ("BUTTON" !== t.tagName) continue;

                    // IMAGE
                    if (t.hasAttribute("data-dimension")) {

                        n = t.getAttribute("data-dimension").split("x");

                        o = {
                            src: t.getAttribute("data-zoom"),
                            w: parseInt(n[0], 10),
                            h: parseInt(n[1], 10),
                            index: e
                        };

                        if (t.children.length > 0) {
                            o.msrc = t.children[0].getAttribute("src");
                        }

                        o.el = t;

                        r.push(o);
                    }

                    // VIDEO
                    else if (t.hasAttribute("data-video")) {

                        o = {
                            html: `
                                <div class="pswp-video-wrapper">
                                    <video
                                        controls
                                        autoplay
                                        playsinline
                                        style="width:100%;height:auto;max-height:90vh;"
                                    >
                                        <source src="${t.dataset.videoSrc}" type="video/mp4">
                                    </video>
                                </div>
                            `,
                            index: e
                        };

                        o.el = t;

                        r.push(o);
                    }
                }
                    return r
                }
            }(n);
            if (!a || !a.length) return;
            let d = n.closest(".product-media-box");
            d && d.classList.add("has-lightbox");
            let c = {
                galleryUID: n.getAttribute("data-pswp-uid"),
                index: t,
                maxSpreadZoom: 2,
                getThumbBoundsFn: function(e) {
                    let t = a[e].el.querySelector("img");
                    if (!t) return {
                        x: 0,
                        y: 0,
                        w: 0
                    };
                    let n = t.getBoundingClientRect(),
                        o = window.pageYOffset || document.documentElement.scrollTop;
                    return {
                        x: n.left,
                        y: n.top + o,
                        w: n.width
                    }
                }
            };
            o && (c.showAnimationDuration = 0);
            let l = new PhotoSwipe(r, PhotoSwipeUI_Default, a, c);
            l.listen("afterChange", function() {

                const video = document.querySelector(
                    ".pswp__container video"
                );

                if(video){
                    video.play().catch(()=>{});
                }

            });
            l.listen("afterChange", function() {

            document.querySelectorAll(".pswp video").forEach(function(video) {
                video.pause();
            });

            const activeVideo = document.querySelector(
                ".pswp__item--active video"
            );

            if (activeVideo) {
                activeVideo.play().catch(() => {});
            }
        });
            l.listen("close", (function() {
                d && d.classList.remove("has-lightbox")
            })), l.init()
        },
        i = e.querySelectorAll(".product-main-slide");
    if (i.length) {
        for (let e = 0, t = i.length; e < t; e++) i[e].setAttribute("data-pswp-uid", e + 1), i[e].onclick = n;
        let e = function() {
            let e = window.location.hash.substring(1),
                t = {};
            if (e.length < 5) return t;
            let n = e.split("&");
            for (let e = 0, o = n.length; e < o; e++) {
                if (!n[e]) continue;
                let o = n[e].split("=");
                o.length < 2 || (t[o[0]] = o[1])
            }
            return t.gid && (t.gid = parseInt(t.gid, 10)), t
        }();
        e.pid && e.gid && o(e.pid, i[e.gid - 1], !0, !0)
    }
}

function btyToggleModal(e = document) {
    let t = e.querySelectorAll(".modal-toggle-button"),
        n = e.querySelector(".product-modal"),
        o = !!n && n.querySelector(".media-modal-toggle");
    t.length && o && (t.forEach((function(e) {
        e.onclick = function() {
            n.classList.add("is-open");
            let t = n.querySelector('[data-media-id="' + e.parentNode.getAttribute("data-media-id") + '"]');
            t && (document.documentElement.classList.add("overflow-hidden"), t.classList.add("active"))
        }
    })), o.onclick = function() {
        let e = n.querySelector(".product-model.active");
        e && e.classList.remove("active"), n.classList.remove("is-open"), document.documentElement.classList.remove("overflow-hidden")
    })
}

function btyStickyAddToCart(e = document) {
    let t = e.querySelector(".sticky-add-to-cart");
    if (!t) return;
    let n = t.querySelector(".sticky-product-image"),
        o = t.querySelector(".product-price"),
        i = (t.querySelector('[data-type="add-to-cart-form"]'), t.closest(".shopify-section").querySelector(".summary-item .product-buy")),
        r = t.querySelector('[name="id"]'),
        a = t.querySelector('[name="add"]'),
        d = t.querySelector(".quantity-input"),
        c = t.closest(".shopify-section").querySelector("[data-product-variants]"),
        l = t.closest(".shopify-section").querySelector("[data-inventory-quantity]"),
        s = t.querySelectorAll(".field-value"),
        u = {};
    c = !!c && btyJsonParse(c.textContent), l = !!l && btyJsonParse(l.textContent), s.length && s.forEach((function(e) {
        u[e.name] = e.value, e.onchange = function() {
            u[e.name] = e.value;
            let t = !!c && btySelectedVariant(u, c);
            if (t && (r && (r.value = t.id), n && t.featured_image && btyImageLoad(n, t.featured_image.src, t.featured_media.id, n.parentNode), o && btySetPriceHtml(o, t.price, t.compare_at_price, t.unit_price, t.unit_price_measurement), d)) {
                let e = l ? l.filter((function(e) {
                    return e.id === t.id
                })) : [];
                if (e.length) {
                    let t = e[0].qty;
                    t > 0 ? (Number(d.value) > t && (d.value = t), d.setAttribute("max", t)) : d.removeAttribute("max")
                } else d.removeAttribute("max")
            }
            a && (t ? t.available ? (a.innerHTML = btyStrings.product.add_to_cart, a.classList.remove("disabled")) : (a.innerHTML = btyStrings.product.out_of_stock, a.classList.add("disabled")) : (a.classList.add("disabled"), a.innerHTML = btyStrings.product.unavailable))
        }
    }));
    let m = e.querySelector(".summary-item.add-to-cart");
    if (!m) return;
    const y = function() {
        a.addEventListener("click", (function() {
            !window.matchMedia("(min-width: 768px)").matches && a.classList.contains("add-product-variants") && i && i.scrollIntoView({
                behavior: "smooth",
                block: "end",
                inline: "end"
            })
        }))
    };
    y();
    new IntersectionObserver((function(e) {
        window.addEventListener("resize", (function() {
            y()
        })), e[0].intersectionRatio <= 0 ? t.classList.add("active") : t.classList.remove("active")
    })).observe(m)
}

function btyProductPerformed(e = document) {
    let t = e.querySelectorAll(".product-performed [data-source]");
    t.length && t.forEach((function(e) {
        let t = e.getAttribute("data-url");
        !e.innerHTML.trim() && t && fetch(t).then((function(e) {
            if (200 !== e.status) throw console.log("Status Code: " + e.status), e;
            return e.text()
        })).then((function(t) {
            e.innerHTML = btyGetSectionHtml(t, "[data-source]"), e.removeAttribute("data-url"), btyAddToCart(e), btyQuickView(e), btySwatch(e), btyAnimationImageLoad(e), btyHoverMediaVideo(e), btyQuickAdd(e), btyScrollAnimationTrigger(e), document.dispatchEvent(new CustomEvent("product-card-updated"))
        })).catch((function(e) {
            console.log(e)
        }))
    }))
}

function btyComplementaryProducts(e = document) {
    let t = e.querySelector(".complementary-products-container");
    if (!t) return;
    let n = t.getAttribute("data-url");
    !t.innerHTML.trim() && n && fetch(n).then((function(e) {
        if (200 !== e.status) throw console.log("Status Code: " + e.status), e;
        return e.text()
    })).then((function(e) {
        t.innerHTML = btyGetSectionHtml(e, ".complementary-products-container"), btyQuickView(t), btySwatch(t), btyAnimationImageLoad(t), btyAddToCart(t), btyAccordionHandle(t)
    })).catch((function(e) {
        console.log(e)
    }))
}

function btyComplementaryProductsMobile(e = document) {
    let t = e.querySelector(".complementary-products-container-mobile");
    if (!t) return;
    let n = t.getAttribute("data-url");
    !t.innerHTML.trim() && n && fetch(n).then((function(e) {
        if (200 !== e.status) throw console.log("Status Code: " + e.status), e;
        return e.text()
    })).then((function(e) {
        t.innerHTML = btyGetSectionHtml(e, ".complementary-products-container-mobile"), btyQuickView(t), btySwatch(t), btyAnimationImageLoad(t), btyAddToCart(t), btyAccordionHandle(t)
    })).catch((function(e) {
        console.log(e)
    }))
}

function btyHandleEmailInputState(e = document) {
    const t = e.querySelector(".email-input"),
        n = e.querySelector(".summary-item.add-to-cart .add-to-cart-button"),
        o = e.querySelector(".error-messages"),
        i = e.querySelector(".recipient-fields"),
        r = e.querySelector('.recipient-fields .text-body[type="date"]');
    if (!t || !n || !i) return;

    function a(e) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e)
    }

    function d(e) {
        n.disabled = e, n.classList.toggle("is-disabled", e), n.setAttribute("aria-disabled", e ? "true" : "false")
    }

    function c() {
        const e = i.classList.contains("open"),
            n = a(t.value.trim());
        if (e && !n) d(!0), o && (o.textContent = t.dataset.emailRequired);
        else {
            const e = l();
            d(!e), o && e && (o.textContent = "")
        }
    }

    function l() {
        if (!r) return !0;
        const e = r.parentNode.querySelector(".date-limit-message") || (() => {
                const e = document.createElement("span");
                return e.className = "message error-message date-limit-message", r.parentNode.appendChild(e), e
            })(),
            t = new Date,
            n = (new Date(r.value) - t) / 864e5,
            o = r.dataset.dateRequired;
        return r.value && n > 90 ? (e.textContent = o, e.style.display = "block", e.style.marginTop = "1.4rem", !1) : (e.textContent = "", e.style.display = "none", !0)
    }
    t.addEventListener("input", c), r && r.addEventListener("change", (() => {
        const e = l(),
            n = a(t.value.trim());
        d(i.classList.contains("open") && (!n || !e))
    }));
    const s = e.querySelector('.recipient-checkbox-label input[type="checkbox"]');
    s && s.addEventListener("change", c), n.addEventListener("click", (function(e) {
        const n = i.classList.contains("open"),
            r = a(t.value.trim()),
            d = l();
        !n || r && d || (e.preventDefault(), e.stopPropagation(), o && !r && (o.textContent = t.dataset.emailRequired || ""))
    })), c()
}
customElements.define("product-model", class extends HTMLElement {
    constructor() {
        super();
        const e = this.querySelector('[id^="deferred-poster-"]');
        e && e.addEventListener("click", this.loadContent.bind(this))
    }
    loadContent() {
        if (!this.getAttribute("loaded")) {
            const e = document.createElement("div");
            e.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(!0)), this.setAttribute("loaded", !0);
            this.appendChild(e.querySelector("model-viewer"))
        }
        Shopify.loadFeatures([{
            name: "model-viewer-ui",
            version: "1.0",
            onLoad: this.setupModelViewerUI.bind(this)
        }])
    }
    setupModelViewerUI(e) {
        e || (this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector("model-viewer")))
    }
}), window.ProductModel = {
    loadShopifyXR() {
        Shopify.loadFeatures([{
            name: "shopify-xr",
            version: "1.0",
            onLoad: this.setupShopifyXR.bind(this)
        }])
    },
    setupShopifyXR(e) {
        e || (window.ShopifyXR ? (document.querySelectorAll('[id^="ProductJSON-"]').forEach((e => {
            window.ShopifyXR.addModels(JSON.parse(e.textContent)), e.remove()
        })), window.ShopifyXR.setupXRElements()) : document.addEventListener("shopify_xr_initialized", (() => this.setupShopifyXR())))
    }
}, document.addEventListener("DOMContentLoaded", (function() {
    window.ProductModel && window.ProductModel.loadShopifyXR(), btyStickyAddToCart(), btyToggleModal(), btyPhotoswipeHandle(), btyProductPerformed(), btyComplementaryProducts(), btyComplementaryProductsMobile(), btyHandleEmailInputState(), window.addEventListener("resize", (function() {
        btyHandleEmailInputState()
    }))
})), document.addEventListener("shopify:section:load", (function(e) {
    let t = e.target.closest("section.shopify-section");
    btyProductPerformed(t), btyComplementaryProducts(t), btyComplementaryProductsMobile(t), btyHandleEmailInputState(t)
})), document.addEventListener("shopify:section:select", (function(e) {
    let t = e.target;
    btyProductPerformed(t), btyStickyAddToCart(t), btyComplementaryProducts(t), btyComplementaryProductsMobile(t), btyHandleEmailInputState(t)
})), document.addEventListener("shopify:block:select", (function(e) {
    let t = e.target.closest(".shopify-section");
    t && (btyStickyAddToCart(t), btyComplementaryProducts(t), btyComplementaryProductsMobile(t), btyHandleEmailInputState(t))
}));